import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import TipTapView from '@pages/CoursesCatalog/components/TipTapView/TipTapView'
import common from '../../common.module.css'

interface IAuthorizationAgreementCheck {
  confirmed: boolean
  onClick: (value: boolean) => void
}

const AuthorizationAgreementCheck: FC<IAuthorizationAgreementCheck> = ({
  confirmed,
  onClick,
}) => {
  const isCustomAuthorizationAgreementStore = useSelector(
    (store: any) => store.settings.isCustomAuthorizationAgreement === '1',
  )
  const authorizationAgreementStore = useSelector(
    (store: any) => store.settings.custom.authorizationAgreementText ?? '',
  )

  const onChange = () => {
    onClick(!confirmed)
  }

  if (!isCustomAuthorizationAgreementStore) return <></>

  return (
    <div className={common.agreement}>
      <div className={common.checkboxWrapper}>
        {/* @ts-ignore */}
        <CheckboxViolet
          className={common.checkbox}
          value={confirmed}
          setValue={onChange}
        />
      </div>
      <TipTapView
        className={common.tiptapAgreementsView}
        value={authorizationAgreementStore}
      />
    </div>
  )
}

export default AuthorizationAgreementCheck
